import { ContactOwner } from './ContactOwner';

export default ContactOwner;
